export function buildTicketPriceCurrencyFromCampaign(campaign: any) {
    const v = ((campaign.offerParams || []).find((x: any) => x.name === 'ticketPriceCurrency') || {}).value;
    if (!v) return undefined;
    return v;
}

// noinspection JSUnusedGlobalSymbols
export default buildTicketPriceCurrencyFromCampaign;
